import { Box, Flex } from "@chakra-ui/react";
import { SwiperSlide } from "swiper/react";
import { PhotoAttribute } from "~/components/Text";
import { useNavbarHeight } from "~/lib/hooks";

export const ThirdPanel = () => {
  const navbarHeight = useNavbarHeight();

  return (
    <Flex
      backgroundColor="blue.400"
      //hides weird half pixel line between these 2 slides;
      boxShadow="0px 0px 0px 1px #60A9DA"
      flexDirection={{base: "column", md: "row"}}
      justifyContent={"space-between"}
    >
      <Flex
        w={{ base: "100%", md: "40%" }}
        flexDir="column"
        mr={{ base: 0, md: -50 }}
        px={{base: 12, md: 8}}
      >
        <Flex
          my={{ base: "20px", md: "70px" }}
          w={{ base: "100%" }}
          maxW="768px"
          h={"100%"}
          aspectRatio={3 / 4}
          borderRadius={{ base: "16px", md: "22px" }}
          bgImage="/golfkimberly.jpg"
          backgroundSize="cover"
          backgroundPosition="center"
          backgroundRepeat="no-repeat"
          align="flex-end"
          justify="flex-start"
          shadow="-10px 10px 10px 2px rgba(10, 10, 9, 0.14)"
          transform={{ base: "rotate(3deg) translateY(10%)", md: "rotate(3deg) translateX(10%)" }}
        >
          {/* <PhotoAttribute>Katie Goldie</PhotoAttribute> */}
        </Flex>
      </Flex>

      <Flex
        bgImage="/cgrclimb.jpg"
        backgroundSize="cover"
        backgroundRepeat="no-repeat"
        flexGrow={1}
        aspectRatio={{base: 3 / 4, md: 16 / 9}}
        alignItems="flex-end"
        justifyContent="flex-end"
        backgroundPosition="center"
      >
        {/* <PhotoAttribute>Keri Medig</PhotoAttribute> */}
      </Flex>
    </Flex>
  );
};

ThirdPanel.displayName = "SwiperSlideThirdPanel";
